import { SUBGRAPH_CONFIG } from 'config';
import { setupSubgraph } from 'common-client';

const { SubgraphContext, SubgraphProvider } = setupSubgraph(SUBGRAPH_CONFIG);
export { SubgraphProvider };
export default SubgraphContext;
